// extracted by mini-css-extract-plugin
export default {"root":"FilesCounter__root--bW1N0","textColorSecondary":"FilesCounter__textColorSecondary--1KcXu","pageTitle":"FilesCounter__pageTitle--1e0wK"};